import React from 'react'
import { Menu } from 'antd'
import { Location, useLocation, useNavigate } from 'react-router'
import { INavItem, navigationSide } from '../../../../config/navigation'
import styles from './Sidebar.module.scss'

const navItems = [...navigationSide]

export const PageSettingsSidebar = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const selectedKeys = React.useMemo(() => getSelectedKeys(navItems, location), [location])
  const onMenuItemClick = React.useCallback((selectedItem: { key: string }) => {
    const item = navItems.find(i => i.key === selectedItem.key)
    if (item) { navigate(item.url) }
  }, [navigate])

  return (
    <Menu
      className={styles.root}
      mode="inline"
      items={navigationSide}
      selectedKeys={selectedKeys}
      onSelect={onMenuItemClick}
    />
  )
}

function getSelectedKeys(items: INavItem[], location: Location): string[] {
  const { pathname } = location
  return items.filter(i => i.url === pathname || (i.include && i.include.find(k => pathname.indexOf(k) === 0))).map(i => i.key)
}
